/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of ImagePromotion condition.
 */
export enum ImagePromotionConditionType {
  ImagePromotionConditionTypeReady = 'Ready',
}
